import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth.js';
import { FullScreenLoader } from './FullScreenLoader.js';
import { Sidebar } from './Sidebar.js';
import { Topbar } from './Topbar.js';

// Shell de rutas protegidas: sin token, redirige a /login (SRS-01 §12).
// Cubre también el acceso directo por URL (ej. refrescar /clientes) — el
// silent refresh corre una sola vez a nivel AuthProvider (ver useAuth.tsx),
// así que 'checking' aplica igual sin importar qué ruta se cargó primero.
export function Layout() {
  const { isAuthenticated, status } = useAuth();

  if (status === 'checking') {
    return <FullScreenLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="app-shell">
      <Sidebar />
      <main className="main">
        <Topbar />
        <div className="content-area">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
